import { useState } from 'react';

import { RadioGroup } from '@components/index';
import ModalV2 from '@layouts/modal/Modal.v2';
import { DueDateOptions, PaymentCollectionComponentType } from '@types';

interface GroupDueDateConsentProps {
  setShowConsent: (value: boolean) => void;
  collectionType: PaymentCollectionComponentType;
  handleConsentConfirm: (consent: DueDateOptions) => void;
}

const GroupDueDateConsent = ({
  setShowConsent,
  collectionType,
  handleConsentConfirm
}: GroupDueDateConsentProps) => {
  const [selectedConsent, setSelectedConsent] = useState<'current' | 'next'>(
    'next'
  );
  const consentType = () => {
    if (collectionType === PaymentCollectionComponentType.MONTHLY)
      return 'month';
    if (collectionType === PaymentCollectionComponentType.WEEKLY) return 'week';
    return '';
  };

  return (
    <ModalV2
      title="Payment link sent"
      onClose={() => setShowConsent(false)}
      primaryButtonLabel="Confirm"
      secondaryButtonLabel="Cancel"
      secondaryButtonClick={() => setShowConsent(false)}
      primaryButtonClick={() => handleConsentConfirm(selectedConsent)}
    >
      <div className="text-base font-medium text-cofeeNeutral10">
        {`The payment link for the current ${consentType()} has already been sent. Select ‘Next ${consentType()}’ to prevent any duplication of payment.`}
      </div>
      <div className="mt-2 text-base font-medium text-cofeeNeutral7">
        {`Choose a ${consentType()} to apply the change.`}
      </div>
      <div className="mt-2 flex flex-col gap-6">
        <RadioGroup
          options={[
            { value: `Next ${consentType()}`, key: 'next' },
            {
              value: `Current ${consentType()}`,
              key: 'current'
            }
          ]}
          selectedValue={selectedConsent}
          handleChange={(value) => setSelectedConsent(value as DueDateOptions)}
          orientation="vertical"
          labelStyle="text-base font-medium"
          iconStyle="!size-4"
          optionClassName="!mb-2"
        />
      </div>
    </ModalV2>
  );
};

export default GroupDueDateConsent;
